// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WAYF","left":"styles_left__1dF_U"};